"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.219a2.4 2.4 0 0 0-.854.14c-.551.208-.693.798-.71 1.245-.038.986-.099 3.232-.11 7.721-4.49.012-6.736.073-7.722.11-.447.018-1.037.16-1.245.71-.083.22-.14.5-.14.855 0 .354.057.635.14.854.208.551.798.693 1.245.71.986.038 3.232.099 7.721.11.012 4.49.073 6.736.11 7.722.018.447.16 1.037.71 1.245.22.083.5.14.855.14a2.4 2.4 0 0 0 .854-.14c.551-.208.693-.798.71-1.245.038-.986.099-3.232.11-7.721 4.49-.012 6.736-.073 7.722-.11.447-.018 1.037-.16 1.245-.71.083-.22.14-.5.14-.855a2.4 2.4 0 0 0-.14-.854c-.208-.551-.798-.693-1.245-.71-.986-.038-3.232-.099-7.721-.11-.012-4.49-.073-6.736-.11-7.722-.018-.447-.16-1.037-.71-1.245-.22-.083-.5-.14-.855-.14Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPlus);
var _default = exports["default"] = Memo;